import { directEntitlementEvalutor } from './direct-entitlement.evaluator';
import { featureFlagEvaluator } from './feature-flag.evaluator';
import { planTargetingRulesEvalutor } from './plan-targeting-rules.evaluator';
import { IsEntitledEvaluator } from './types';

export function getIsEntitledEvaluators(): IsEntitledEvaluator[] {
  return [directEntitlementEvalutor, featureFlagEvaluator, planTargetingRulesEvalutor];
}
